__turbopack_context__.v({
  "insuranceWarningAside": "calculatorSections-module-scss-module__arp9KW__insuranceWarningAside",
  "insuranceWarningInline": "calculatorSections-module-scss-module__arp9KW__insuranceWarningInline",
  "nextButton": "calculatorSections-module-scss-module__arp9KW__nextButton",
  "question": "calculatorSections-module-scss-module__arp9KW__question",
  "sectionAd": "calculatorSections-module-scss-module__arp9KW__sectionAd",
  "sectionAdImage": "calculatorSections-module-scss-module__arp9KW__sectionAdImage",
  "sectionAdImageImg": "calculatorSections-module-scss-module__arp9KW__sectionAdImageImg",
  "sectionAdText": "calculatorSections-module-scss-module__arp9KW__sectionAdText",
  "sectionAdTitle": "calculatorSections-module-scss-module__arp9KW__sectionAdTitle",
  "sectionAmount": "calculatorSections-module-scss-module__arp9KW__sectionAmount",
  "sectionAmountLabel": "calculatorSections-module-scss-module__arp9KW__sectionAmountLabel",
  "sectionAmountSubLabel": "calculatorSections-module-scss-module__arp9KW__sectionAmountSubLabel",
  "sectionAmountValue": "calculatorSections-module-scss-module__arp9KW__sectionAmountValue",
  "sectionBody": "calculatorSections-module-scss-module__arp9KW__sectionBody",
  "sectionContent": "calculatorSections-module-scss-module__arp9KW__sectionContent",
  "sectionFooter": "calculatorSections-module-scss-module__arp9KW__sectionFooter",
  "sectionGroup": "calculatorSections-module-scss-module__arp9KW__sectionGroup",
  "sectionTitle": "calculatorSections-module-scss-module__arp9KW__sectionTitle",
  "stepCard": "calculatorSections-module-scss-module__arp9KW__stepCard",
  "stepIcon": "calculatorSections-module-scss-module__arp9KW__stepIcon",
  "stepLabel": "calculatorSections-module-scss-module__arp9KW__stepLabel",
  "stepsGrid": "calculatorSections-module-scss-module__arp9KW__stepsGrid",
  "stepsSection": "calculatorSections-module-scss-module__arp9KW__stepsSection",
});
